import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";
import {Observable, of, ReplaySubject, switchMap, tap, throwError} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private _authenticated: boolean = false;

  private _user: ReplaySubject<any> = new ReplaySubject<any>(1);

  /**
   * Constructor
   */
  constructor(private _apiService: ApiService) {

  }

  /**
   * Setter & getter for user
   *
   * @param value
   */
  set user(value: any)
  {
    // Store the value
    this._user.next(value);
  }

  get user$(): Observable<any>
  {
    return this._user.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get the current logged in user data
   */
  getUser(): Observable<any>
  {
    return this._apiService.getLoggedUser().pipe(
      tap((user) => {
        this._user.next(user);
      })
    );
  }

  /**
   * Sign in
   *
   * @param credentials
   */
  signIn(credentials: { email: string; password: string }): Observable<any>
  {
    // Throw error, if the user is already logged in
    if ( this._authenticated )
    {
      return throwError('User is already logged in.');
    }

    return this._apiService.postLogin( credentials).pipe(
      switchMap((response: any) => {

        // Store the access token in the local storage
        this.accessToken = response.accessToken;

        // Store the refresh token in the local storage
        this.refreshToken = response.refreshToken;

        // Set the authenticated flag to true
        this._authenticated = true;
        // Return a new observable with the response
        return of(response);
      })
    );
  }



  /**
   * Setter & getter for access token
   */
  set accessToken(token: string | null)
  {
    if(token)
      localStorage.setItem('accessToken', token);
    else
      localStorage.removeItem('accessToken');
  }

  get accessToken(): string | null
  {
    return localStorage.getItem('accessToken') && (localStorage.getItem('accessToken') !== 'undefined') ? localStorage.getItem('accessToken') : '';
  }

  /**
   * Setter & getter for access token
   */
  set refreshToken(token: string)
  {
    localStorage.setItem('refreshToken', token);
  }

  get refreshToken(): string
  {
    return localStorage.getItem('refreshToken') ?? '';
  }

  unauthenticate()
  {
    this._authenticated = false;
  }



}
